import { getEnvConfig } from '@/utils/env'

export function useGlobalSettings() {
  const {
    VITE_GLOB_API_URL,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_IMAGE_URL,
    VITE_PDA_URL,
    VITE_GLOB_SENTRY_DSN,
    VITE_ENABLE_SENTRY,
  } = getEnvConfig()

  return {
    baseURL: VITE_GLOB_API_URL,
    urlPrefix: VITE_GLOB_API_URL_PREFIX,
    appTitle: VITE_GLOB_APP_TITLE,
    imageUrl: VITE_GLOB_IMAGE_URL,
    pdaUrl: VITE_PDA_URL,
    sentryDSN: VITE_GLOB_SENTRY_DSN,
    enableSentry:
      typeof VITE_ENABLE_SENTRY === 'boolean'
        ? VITE_ENABLE_SENTRY
        : VITE_ENABLE_SENTRY === 'true'
        ? true
        : false,
  }
}
